
import NavBar from '../components/NavBar.vue'
import HeaderBar from '../components/HeaderBar.vue'
import ClassModal from '@/components/ClassModal.vue'
import AppSuccessModal from '@/components/AppSuccessModal.vue'
import MaintenanceAlert from '~/components/MaintenanceAlert.vue'

export default {
  name: 'IndexPage',
  components: {
    AppSuccessModal,
    NavBar,
    HeaderBar,
    ClassModal,
    MaintenanceAlert,
  },
  middleware: ['authentication'],
  data() {
    return {
      isOpened: true,
      header: true,
      controlMenu: true,
      img: '/img/standardUser.svg',
    }
  },
  computed: {
    user() {
      return this.$store.state.credential
    },
    className() {
      return localStorage.className
    },
    isOpenNavBar() {
      return this.$store.state.navbar.isOpenNavBar
    },
    successModal() {
      return this.$store.state.modal.success
    },
  },
  async created() {
    const response = await this.$axios.get('/api/v1/academic/customer')
    if (response.data.image) {
      const newImageURL = response.data.image
      this.$store.commit('credential/updateImage', newImageURL)
      this.img = newImageURL
    } else {
      this.$store.commit('credential/updateImage', this.img)
    }
  },
}
